import React from 'react'
import t from 'prop-types'

function AccesoIndice ({ accion, onAccion } ) {
    return (
        <div className="accesoPortada" onClick={ () => onAccion(accion) } >{ accion.texto }</div>
    )
}

AccesoIndice.propTypes = {
    accion: t.shape(
        {
            texto: t.string.isRequired,
            indice: t.string,
            pantalla: t.string,
            zona: t.string
        }
    ).isRequired,
    onAccion: t.func.isRequired
}

export default AccesoIndice